import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@/store/store";
import type { QuoteCalculatorSlice } from "./types/quoteCalculator";

const initialState: QuoteCalculatorSlice = {
  lender: "",
  loanAmount: 0,
  repayments: 0,
  rate: 0,
  fees: [],
  effectiveRate: 0,
  templateId: "",
};

export const quoteCalculatorSlice = createSlice({
  name: "quoteCalculator",
  initialState,
  reducers: {
    setQuoteCalculator: (state, action: PayloadAction<Partial<QuoteCalculatorSlice>>) => ({
        ...state,
        ...action.payload,
      }),
    resetQuoteCalculator: () => initialState,
  },
});

export const { setQuoteCalculator, resetQuoteCalculator } = quoteCalculatorSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const quoteCalculatorSelector = (state: RootState) => state.quoteCalculator;

export default quoteCalculatorSlice.reducer;
